/*
  THAANI — Benefits: Wort-fuer-Wort-Reveal beim Scrollen.
  Vanilla JS, kein Framework.

  Grundzustand im CSS ist volle Deckkraft. Erst wenn hier alles vorhanden ist
  (JS aktiv, IntersectionObserver verfuegbar, keine reduzierte Bewegung), wird
  .is-armed gesetzt und der Startzustand 0.15 aktiv. So bleibt die Headline
  ohne JS und bei prefers-reduced-motion jederzeit voll lesbar.
*/

class ThaaniBenefitsReveal extends HTMLElement {
  connectedCallback() {
    if (this.observer) return;

    this.words = Array.from(this.querySelectorAll('.thaani-benefits__word'));
    if (this.words.length === 0) return;

    if (typeof IntersectionObserver === 'undefined') return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.reducedMotion.matches) return;

    this.classList.add('is-armed');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.reveal();
        });
      },
      { rootMargin: '0px 0px -15% 0px', threshold: 0.25 }
    );

    this.observer.observe(this);

    this.onMotionChange = this.handleMotionChange.bind(this);
    if (typeof this.reducedMotion.addEventListener === 'function') {
      this.reducedMotion.addEventListener('change', this.onMotionChange);
    }
  }

  disconnectedCallback() {
    this.disconnectObserver();

    if (this.reducedMotion && typeof this.reducedMotion.removeEventListener === 'function') {
      this.reducedMotion.removeEventListener('change', this.onMotionChange);
    }
  }

  handleMotionChange(event) {
    if (!event.matches) return;

    // Nutzer schaltet mitten im Besuch auf reduzierte Bewegung: sofort statisch.
    this.disconnectObserver();
    this.classList.remove('is-armed', 'is-revealed');
  }

  reveal() {
    this.classList.add('is-revealed');
    this.disconnectObserver();
  }

  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
  }
}

if (!customElements.get('thaani-benefits-reveal')) {
  customElements.define('thaani-benefits-reveal', ThaaniBenefitsReveal);
}
